<template>
  <div class="page-background">
  <ResourceComponent></ResourceComponent>
  
  </div>
</template>
<script>
import ResourceComponent from '../components/ResourceComponent.vue';
export default {
  components:{
    ResourceComponent
  },
}
</script>
<style>
.page-background {
  background-image: url("../assets/forest.jpg");
  background-repeat: no-repeat;
  background-size: cover;
}
</style>